export default __webpack_public_path__ + "static/media/megane-gallery-3.872d8ed7.jpg";